// extracted by mini-css-extract-plugin
export default {"wrapper":"dE-z","viewport":"eE-z","container":"fE-z","slide":"gE-z"};